var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"mb-4"},[_c('v-toolbar-title',[_vm._t("default")],2),_c('v-spacer'),_c('v-toolbar-items',{staticClass:"pa-2"},[_vm._t("actions")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }